

export const routeOnClick = (history, route) => (e)=>{

    e && e.preventDefault && e.preventDefault();
    history.push(route);

};